import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/permission/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getSystemModuleNames = (params, urlParams) => {
  return axios.request({
    url: '/permission/getsystemmodulenames' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

